import { productReviewVoted, storeReviewVoted } from '../tracking';

export const CREATE_REVIEW = 'CREATE_REVIEW';
export const EDIT_REVIEW = 'EDIT_REVIEW';
export const DELETE_REVIEW = 'DELETE_REVIEW';

export const OPEN_REVIEW_DIALOG = 'OPEN_REVIEW_DIALOG';
export const CLOSE_REVIEW_DIALOG = 'CLOSE_REVIEW_DIALOG';

export const UPDATE_REVIEW_DATA = 'UPDATE_REVIEW_DATA';
export const REVIEW_REQUEST_ERROR = 'REVIEW_REQUEST_ERROR';

export const REPORT_REVIEW = 'REPORT_REVIEW';
export const REPORT_REVIEW_SUCCESS = 'REPORT_REVIEW_SUCCESS';
export const REPORT_REVIEW_FAILED = 'REPORT_REVIEW_FAILED';

export const LIKE_REVIEW_TOGGLE = 'LIKE_REVIEW_TOGGLE';
export const LIKE_REVIEW_SUCCESS = 'LIKE_REVIEW_SUCCESS';
export const LIKE_REVIEW_FAILED = 'LIKE_REVIEW_FAILED';

export const createReview = ({
  belongsToId,
  rating,
  reviewType,
  reviewText,
  purchaseDate,
  displayName,
}) => ({
  type: CREATE_REVIEW,
  belongsToId,
  rating,
  reviewType,
  reviewText,
  purchaseDate,
  displayName,
});

export const editReview = ({
  reviewId,
  belongsToId,
  reviewType,
  rating,
  reviewText,
  purchaseDate,
}) => ({
  type: EDIT_REVIEW,
  reviewId,
  belongsToId,
  reviewType,
  rating,
  reviewText,
  purchaseDate,
});

export const deleteReview = ({ reviewId, belongsToId, reviewType }) => ({
  type: DELETE_REVIEW,
  reviewId,
  reviewType,
  belongsToId,
});

export const openReviewDialog = reviewItem => ({
  type: OPEN_REVIEW_DIALOG,
  reviewItem,
});

export const closeReviewDialog = () => ({
  type: CLOSE_REVIEW_DIALOG,
});

export const updateReviewData = (reviewType, userReviews, id, actionType) => ({
  type: UPDATE_REVIEW_DATA,
  userReviews,
  reviewType,
  id,
  actionType, // The action triggering this: `CREATE`, `EDIT` or `DELETE`
});

export const reviewRequestError = () => ({
  type: REVIEW_REQUEST_ERROR,
});

export const reportReview = (reviewId, message, email) => ({
  type: REPORT_REVIEW,
  reviewId,
  message,
  email,
});

export const reportReviewSuccess = () => ({ type: REPORT_REVIEW_SUCCESS });

export const reportReviewFailed = message => ({
  type: REPORT_REVIEW_FAILED,
  message,
});

export const likeReviewToggle = (id, reviewType) => {
  return {
    type: LIKE_REVIEW_TOGGLE,
    id,
    reviewType,
  };
};

export const likeReviewSuccess = (id, value, reviewType) => {
  switch (reviewType) {
    case 'product':
      productReviewVoted(value);
      break;
    case 'store':
      storeReviewVoted(value);
      break;
    default:
      break;
  }

  return {
    type: LIKE_REVIEW_SUCCESS,
    id,
    value,
  };
};

export const likeReviewFailed = () => {
  return {
    type: LIKE_REVIEW_FAILED,
  };
};

export default {
  editReview,
  createReview,
  deleteReview,

  openReviewDialog,
  closeReviewDialog,

  reportReview,
  reportReviewSuccess,
  reportReviewFailed,
};
